import { getTaxFullUrl, getVerificationBypass } from '../../../shared/utils';

async function startVerification(
  phone: string,
  verificationType: string,
  postalCode = '',
  baseURL = getTaxFullUrl()
) {
  const bypassVerificationQueryParam = getVerificationBypass();

  // The postal code is only sent alongside a bypass: in prod the backend only honours the bypass
  // for the synthetic postal code, so a leaked bypass key can't reach a real pro.
  const payload =
    bypassVerificationQueryParam?.length > 0
      ? {
          phoneNumber: phone,
          type: verificationType,
          bypassVerificationQuery: bypassVerificationQueryParam,
          postalCode
        }
      : {
          phoneNumber: phone,
          type: verificationType
        };

  const fullUrl = `${baseURL}/api/phone-validation-start/`;
  const response = await fetch(fullUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  return await response.json();
}

export { startVerification };
